<template>
  <div class="accountStatementsDetail">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList()"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.clientFund.inquiryNumber }}：{{ item.PaymentInquiryNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.fillInDate }} / {{ $t.clientFund.receiveDate
          }}{{ item.FillInOrReceiveDate }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.entryType }}：
          <span v-if="item.EntryType == 1">{{ $t.clientFund.type1 }}</span>
          <span v-if="item.EntryType == 2">{{ $t.clientFund.type2 }}</span>
        </div>
        <div class="list-item">
          {{ $t.clientFund.fundClass }}：
          <span v-if="item.PaymentType == 1">{{ $t.clientFund.paymentType1 }}</span>
          <span v-if="item.PaymentType == 2">{{ $t.clientFund.paymentType2 }}</span>
        </div>
        <div class="list-item">
          {{ $t.clientFund.entryState }}：
          <span v-if="item.EntryState == 0">{{ $t.clientFund.entryState3 }}</span>
          <span v-if="item.EntryState == 1">{{ $t.clientFund.entryState1 }}</span>
          <span v-if="item.EntryState == 2">{{ $t.clientFund.entryState2 }}</span>
        </div>
        <div class="list-item">
          {{ $t.clientFund.accountName }}：{{ item.AccountName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.customerNumber }}：{{ item.CustomerNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.customerName }}：{{ item.CustomerName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.remitterName }}：{{ item.RemitterName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.remittanceLocation }}：{{ item.RemittanceLocation }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.remittanceAmount }}：{{ item.RemittanceAmount }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.remittanceCurrency }}：{{ item.RemittanceCurrencyStr }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.bankCharges }}：{{ item.BankCharges }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.bankChargesCurrency }}：{{ item.BankChargesCurrencyStr }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.receivedAmount }}：{{ item.ReceivedAmount }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.receivedCurrency }}：{{ item.ReceivedCurrencyStr }}
        </div>
        <div class="list-item">{{ $t.clientFund.remark }}：{{ item.Remark }}</div>
        <div class="list-item">{{ $t.clientFund.agent }}：{{ item.UserName }}</div>
        <div class="buttons" v-if="item.FileCount">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item.CEId)"
            >{{ $t.clientFund.entryFile }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-dialog
      :title="$t.clientFund.entryFile"
      width="90%"
      v-model="dialogVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
    >
      <slot name="default">
        <div class="accountStatementsDetail-alert">
          <van-form label-width="120px">
            <div class="multi-table" v-if="entryFileList">
              <div v-for="(item, index) in entryFileList" :key="index">
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-image
                      :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                      @click="imagePreview(imgUrlFilter(item.FileAddress))"
                      width="50"
                      height="50"
                      fit="contain"
                      style="vertical-align: top"
                      v-if="item.FileAddress"
                    ></van-image>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import { List, Row, Col, Button, Form, Field, Image } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field).use(Image);

export default {
  name: "accountStatementsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      dialogVisible: false,
      CTId: "",
      entryFileList: [],
    };
  },
  created() {
    const { CTId } = this.$route.query;
    this.CTId = CTId;
  },
  methods: {
    getList() {
      var param = {
        CTId: this.CTId,
      };
      this.$api.financialManagement
        .getCustomerCapitalTransferDetailByCTId(param)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    dialogShow(id) {
      this.getCustomerCapitalEntryFileListByCEId(id).then((success) => {
        if (success) this.dialogVisible = true;
      });
    },
    getCustomerCapitalEntryFileListByCEId(id) {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          CEId: id,
        };
        this.$api.financialManagement
          .getCustomerCapitalEntryFileListByCEId(param)
          .then((res) => {
            this.entryFileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.accountStatementsDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .accountStatementsDetail-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    .multi-table {
      .multi-table-header {
        background: #ffffff;
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
